import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper } from '@mui/material';
import ListAppContentLabels from '../app-content/list-app-content-labels.component';

const AppWebsiteFields = ({ channelDetail, viewMode }) => (
  <Box component={Paper} p={2} width="100%">
    <ListAppContentLabels channelId={channelDetail.id} viewMode={viewMode} />
  </Box>
);

AppWebsiteFields.propTypes = {
  channelDetail: PropTypes.object.isRequired,
  viewMode: PropTypes.bool,
};
AppWebsiteFields.defaultProps = {
  viewMode: false,
};

export default AppWebsiteFields;
